import Base from './action-base'
import renderFields from './unflag.pug'

export default class Unflag extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-eraser"

  @DEFAULTS:
    names: []

  renderFields: renderFields

  onSave: (newData)->
    newData.names = newData.names.filter((s) => s.length)
